import {
  COMPUTED_ALLOCATION_ACCOUNT_CODE,
  COMPUTED_ALLOCATION_ACCOUNT_ID,
  COMPUTED_ALLOCATION_ACCOUNT_TYPE,
  USER_PROFILE_ALLOCATIONS,
} from '@/constants/engine';
import {registerPluginFilters} from '@/engine/processor/plugin';
import {DependencyRegistrer, ModelFactory} from '@/engine/types';
import {getValueDependencies} from '@/engine/utils/dependencies';
import {PluginValue} from '@/model/types/plugin';
import {Reference} from '@/model/types/reference';
import {Allocation} from '@/repositories/beneva-api/endpoints/allocations';

export const registerAllocationPluginFiltersDependencies = (
  options: PluginValue,
  context: {dependencyRegistrer?: DependencyRegistrer},
) => {
  options.filters?.forEach(filter => {
    context.dependencyRegistrer?.('all', ...getValueDependencies(filter.value));

    switch (filter.property) {
      case 'id':
        context.dependencyRegistrer?.('all', `_${COMPUTED_ALLOCATION_ACCOUNT_ID.split('#')[0]}#*`);
        break;
      case 'code':
        context.dependencyRegistrer?.('all', `_${COMPUTED_ALLOCATION_ACCOUNT_CODE.split('#')[0]}#*`);
        break;
      case 'type':
        context.dependencyRegistrer?.('all', `_${COMPUTED_ALLOCATION_ACCOUNT_TYPE.split('#')[0]}#*`);
        break;
    }
  });
};

export const createAllocationListOptions = (
  options: PluginValue,
  context: {dependencyRegistrer?: DependencyRegistrer},
): ModelFactory<Reference[]> => {
  registerPluginFilters(options, context);

  return valueResolver => {
    const allocations = valueResolver({$ref: USER_PROFILE_ALLOCATIONS});
    const parsedAllocations: Allocation[] = allocations ? JSON.parse(allocations) : [];

    const allocationOptions = valueResolver(
      {$ref: `_${USER_PROFILE_ALLOCATIONS}[options]`},
      {keepDomainReference: true},
    );
    if (!allocationOptions) return [];

    const allocationRefs: string[] = JSON.parse(allocationOptions);
    return allocationRefs
      .filter(allocationRef => {
        if (options.filters) {
          const allocationId = allocationRef.split('_')[1];
          const allocation = parsedAllocations.find(a => a.id === allocationId);

          if (!allocation) return false;

          return options.filters.every(filter => {
            switch (filter.property) {
              case 'id':
                return allocation.id === valueResolver(filter.value);
              case 'name':
                return allocation.name === valueResolver(filter.value);
              case 'type':
                return valueResolver({$ref: allocation.accountType as string}) === valueResolver(filter.value);
              default:
                return false;
            }
          });
        }

        return true;
      })
      .map((allocationRef: string) => ({$ref: allocationRef}));
  };
};
